// Add this to your translation config file

export const campReportTranslations = {
    en: {
        // Page Title
        pageTitle: "Community Health Camp Report",
        selectCamp: "Select Health Camp",

        // Header
        govtTitle: "Government of Maharashtra",
        officeTitle: "Chief Minister's Assistance Fund & Charitable Hospital Help Desk",

        // Table Headers
        description: "Description",
        countDetails: "Count / Details",

        // Report Fields (English only)
        campName: "1. Camp Name",
        campLocation: "2. Camp Location",
        date: "3. Date",
        participatingHospitals: "4. Participating Hospitals (Count & Names)",
        voluntaryOrgs: "5. Voluntary Organizations (Count)",
        medicalColleges: "6. Medical Colleges (Count)",
        departmentWiseDetails: "7. Department-wise Patient Details",

        // Medical Departments
        medicine: "Medicine",
        surgery: "Surgery",
        orthopaedics: "Orthopaedics",
        paediatrics: "Paediatrics",
        gynaecology: "Gynaecology",
        ent: "ENT",
        ophthalmology: "Ophthalmology",
        dermatology: "Dermatology",
        otherDiseases: "Patients with Other Diseases",

        // Additional Fields
        abhaCardCount: "8. Ayushman Bharat / ABHA Card Registrations",
        bloodDonors: "9. Blood Donors in Blood Donation Camp (Count)",
        bloodTestPatients: "10. Patients Blood Tested (Count)",
        ecgTestPatients: "11. Patients ECG Tested (Count)",
        organDonation: "12. Patients Consented for Organ Donation (Count)",
        schemeReferrals: "13. Patients Referred Under Various Schemes (Count)",

        totalPatients: "Total Participating Patients",

        // Messages
        loadingReport: "Loading report...",
        noCampsFound: "No completed camps found",
        fetchReportError: "Failed to fetch camp report",
        noCampsAvailable: "No completed camps available",
        selectCampPrompt: "Please select a camp to view the report"
    },
    mr: {
        // Page Title
        pageTitle: "आरोग्य शिबिर अहवाल",
        selectCamp: "आरोग्य शिबिर निवडा",

        // Header
        govtTitle: "महाराष्ट्र शासन",
        officeTitle: "मुख्यमंत्री सहाय्यता निधी व धर्मादाय रुग्णालय मदत कक्ष",

        // Table Headers
        description: "विवरण",
        countDetails: "संख्या / तपशील",

        // Report Fields (Marathi only)
        campName: "१. शिबिराचे नाव",
        campLocation: "२. शिबिराचे ठिकाण",
        date: "३. दिनांक",
        participatingHospitals: "४. सहभागी रुग्णालये (संख्या व नावे)",
        voluntaryOrgs: "५. सेवाभावी संस्था (संख्या)",
        medicalColleges: "६. वैद्यकीय महाविद्यालये (संख्या)",
        departmentWiseDetails: "७. शिबिरातील सहभागी रुग्णांचे चिकित्सा विभाग अनुरूप विवरण",

        // Medical Departments
        medicine: "कायचिकित्सा विभाग",
        surgery: "शल्य तंत्र विभाग",
        orthopaedics: "अस्थीविकार विभाग",
        paediatrics: "बालरोग विभाग",
        gynaecology: "स्त्रीरोग विभाग",
        ent: "कान - नाक - घसा विभाग",
        ophthalmology: "नेत्रविकार विभाग",
        dermatology: "त्वचा विकार विभाग",
        otherDiseases: "इतर विकार / व्याधी ग्रस्त रुग्ण",

        // Additional Fields
        abhaCardCount: "८. आयुष्मान भारत / आभा कार्ड नोंदणी करण्यात आलेले रुग्णांची संख्या",
        bloodDonors: "९. रक्तदान शिबिरात सहभागी रक्तदाते (संख्या)",
        bloodTestPatients: "१०. शिबिराद्वारे रक्ततपासणी केलेल्या रुग्णांची संख्या",
        ecgTestPatients: "११. शिबिराद्वारे ECG तपासणी करण्यात आलेल्या रुग्णांची संख्या",
        organDonation: "१२. शिबिराद्वारे अवयव दान करीता लिखित संमती पत्र देणारे रुग्णांची संख्या",
        schemeReferrals: "१३. विविध योजना अधिन संदर्भित रुग्णांची संख्या",

        totalPatients: "एकूण सहभागी रुग्णांची संख्या",

        // Messages
        loadingReport: "अहवाल लोड होत आहे...",
        noCampsFound: "कोणतेही पूर्ण झालेले शिबिर आढळले नाही",
        fetchReportError: "शिबिर अहवाल आणण्यात अयशस्वी",
        noCampsAvailable: "कोणतेही पूर्ण झालेले शिबिर उपलब्ध नाही",
        selectCampPrompt: "अहवाल पाहण्यासाठी कृपया शिबिर निवडा"
    }
};
